import { ISVGProps } from 'interfaces/svg';
import styles from 'components/hireUsButton/hireUsButton.module.css';

export const VelvetyWebSpinningText = ({
    width = '180px',
    height = '180px',
    fill = 'white',
}: ISVGProps) => {
    return (
        <svg
            id={styles.rotatingCircleText}
            viewBox="0 0 200 200"
            width={width}
            height={height}
            fill={fill}
        >
            <defs>
                <path
                    id="circle"
                    d="M 100, 100
            m -75, 0
            a 75, 75 0 1, 0 150, 0
            a 75, 75 0 1, 0 -150, 0
            "
                ></path>
            </defs>
            <text width="400">
                <textPath xlinkHref="#circle" className={styles.text}>
                    Velvety Web&nbsp;&nbsp;&nbsp;Velvety
                    Web&nbsp;&nbsp;&nbsp;Velvety Web&nbsp;&nbsp;&nbsp;
                </textPath>
            </text>
        </svg>
    );
};
